const TextareaField = ({ name, label, value, onChange, placeholder, error, required = false, rows = 4 }) => (
  <div>
    <label className="block text-sm font-semibold text-gray-700 mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <textarea 
      name={name} 
      value={value} 
      onChange={onChange} 
      rows={rows} 
      className={`w-full p-2 border rounded-md ${error ? 'border-red-500' : 'border-gray-300'}`} 
      placeholder={placeholder} 
    />
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

export default TextareaField;